import { z } from "zod";

export const DOCUMENT_VARIABLE_KEYS = [
  "clientName",
  "clientIdNumber",
  "clientDateOfBirth",
  "clientPhone",
  "currentDate",
  "currentDosage",
  "requestedDosage",
] as const;

export type TDocumentVariableKey = (typeof DOCUMENT_VARIABLE_KEYS)[number];

export const DOCUMENT_VARIABLE_LABELS: Record<TDocumentVariableKey, string> = {
  clientName: "שם הלקוח",
  clientIdNumber: "תעודת זהות",
  clientDateOfBirth: "תאריך לידה",
  clientPhone: "טלפון",
  currentDate: "תאריך נוכחי",
  currentDosage: "מינון נוכחי",
  requestedDosage: "מינון מבוקש",
};

export type TDocumentVariableValues = Record<TDocumentVariableKey, string>;

export const DocumentVariableValuesSchema: z.ZodType<TDocumentVariableValues> = z.object({
  clientName: z.string().max(200),
  clientIdNumber: z.string().max(200),
  clientDateOfBirth: z.string().max(200),
  clientPhone: z.string().max(200),
  currentDate: z.string().max(200),
  currentDosage: z.string().max(300),
  requestedDosage: z.string().max(300),
});
